import { Discount, Price } from 'shared-types/Common';

export const toNightlyPrice = (
  pricePerStay: Price | undefined,
  discount: Discount | null | undefined,
  numberOfNights: number
): Price | undefined => {
  const stayPrice = discount?.discountedPrice ?? pricePerStay;

  return stayPrice && numberOfNights > 0
    ? { ...stayPrice, amount: stayPrice.amount / numberOfNights }
    : undefined;
};
